const bannedAttributes = ["id"];

/** Strip banned attributes from incoming HTML + any event attributes */
export const stripBannedAttributes = (attributes: Record<string, string>) =>
  Object.fromEntries(
    Object.entries(attributes).filter(
      ([key]) => !bannedAttributes.includes(String(key).toLowerCase()) || (key[0] === "o" && key[1] === "n"),
    ),
  );
